var config = require('./config/index');
var display = require('./config/display');
var pages = require('./config/pages');
var applist = require('./config/applist');

if (typeof Object.assign != 'function') {
  Object.assign = function(target) {
      'use strict';
      if (target == null) {
          throw new TypeError('Cannot convert undefined or null to object');
      }

      target = Object(target);
      for (var index = 1; index < arguments.length; index++) {
          var source = arguments[index];
          if (source != null) {
              for (var key in source) {
                  if (Object.prototype.hasOwnProperty.call(source, key)) {
                      target[key] = source[key];
                  }
              }
          }
      }
      return target;
  };
}
var configs = Object.assign({},config,display,pages,applist);

module.exports = {
  addRoute: function(router,$this){
    for(var key in configs){
      var route = configs[key];
      // 用闭包处理回调函数只拿到最后的变量
      (function(arg){
        router.addRoute(arg.url, function(req, next){
          $this.clear();
          if(arg.initRoute){
            arg.initRoute();
          }
          if(arg.callback){
            arg.callback(req, next);
          }
          $this.reloadPage(arg.page);
        })
      })(route)
    }
  },
  config: configs
}


//////////////////
// WEBPACK FOOTER
// ./src/routes/routeUtils.js
// module id = 184
// module chunks = 0